import $ from 'jquery';

/**
 * Booking form
 */

function BookingForm(el) {
  this.$el = $(el);
  this.$hotels = this.$el.find('.js-hotels');
  this.$accommodationsTrue = this.$el.find('#accommodationsTrue');
  this.$accommodationsFalse = this.$el.find('#accommodationsFalse');

  this.determineHotels(true);

  var self = this;

  this.$accommodationsTrue.on('click', function () {
    self.determineHotels();
  });

  this.$accommodationsFalse.on('click', function () {
    self.determineHotels();
  });

  if (!Modernizr.inputtypes.date) {

    this.$el.find('input[type="date"]').each(function () {
      var $input = $(this),
          opts,
          min = $input.attr('min'),
          max = $input.attr('max');

      opts = {
        dateFormat: 'yy-mm-dd'
      };

      if (min) {
        opts['minDate'] = min;
      }

      if (max) {
        opts['maxDate'] = max;
      }

      $(this).datepicker(opts);
    });
  }
}

BookingForm.prototype.determineHotels = function (dontAnimate) {
  dontAnimate = dontAnimate || false;

  if(this.$accommodationsTrue.is(':checked')) {
    if (dontAnimate) {
      this.$hotels.show();
    } else {
      this.$hotels.slideDown(250);
    }
  } else {
    if (dontAnimate) {
      this.$hotels.hide();
    } else {
      this.$hotels.slideUp(250);
    }
  }
};

$(function () {
  var $bkngFrm = $('.js-booking-form');
  if ($bkngFrm.length === 1) {
    var bookingForm = new BookingForm($bkngFrm);
  }

  window.P5 = window.P5 || {};
  window.P5.bookingForm = bookingForm || false;
});
